export default {
    text: {
        mainPage: {
            newsBlockTitle: 'Nouvelles',
            newsBlockSubTitle: 'e-enduro petit texte sympa en trois lignes, à partir duquel vous souhaitez acheter',
            newsBlockSeeAllBtn: 'Voir tout',
            comingSoon: 'Bientôt disponible',
            showMoreInfoAboutBike: 'Montre plus',
            buyBikeBtn: 'Acheter'
        },
        footer: {
            text: 'Si une disposition (ou une partie d\'une disposition) des présentes conditions générales est jugée illégale, invalide ou inapplicable en vertu de toute loi applicable, cette condition sera, dans la mesure où elle est séparable des autres conditions, réputée omise du présent accord et ne doit en aucun cas affecter la légalité, la validité ou le caractère exécutoire des conditions restantes. car il est séparable des conditions restantes, être considéré comme omis du présent accord et n\'affectera en aucune manière la légalité, la validité ou l\'applicabilité des conditions restantes.Si une disposition (ou une partie d\'une disposition) des présentes conditions générales s\'avère être illégal, invalide ou inapplicable en vertu de toute loi applicable, ce terme sera, dans la mesure où il est séparable des autres termes, réputé omis du présent accord et n\'affectera en aucune manière la légalité',
            legalLinkText: 'Juridique',
            copyright: 'Copyright © 2020 forestal Inc. Tous droits réservés.'
        }
    }
};
